module.exports = __webpack_public_path__ + "static/best-practice-7cef24ddedf568211ff55796a6acbfb7.png";